import { ParamMap, Params } from '@angular/router';
import { IBase } from 'src/app/models';
import { SuggestionSortType } from 'src/app/models/enums';
import { SuggestionPriority } from 'src/app/models/enums/suggestionPriority';
import { SuggestionStatus } from 'src/app/models/enums/suggestionStatus';
import { SuggestionType } from 'src/app/models/enums/suggestionType';
import {
  parseEnumList,
  parseIdList,
  parseNumberList,
  serializeIdList,
  serializeNumberList,
  serializeStringList,
} from './filterUtils';

export const DEFAULT_SUGGESTION_SORT = SuggestionSortType.LAST_MODIFICATION;

export interface ISuggestionsFilters {
  selectedClients: number[];
  selectedTowns: number[];
  selectedServices: IBase[];
  selectedTypes: SuggestionType[];
  selectedStatus: SuggestionStatus[];
  selectedPriorities: SuggestionPriority[];
}

export const SUGGESTION_FILTER_KEYS = [
  'clients', 'towns', 'services', 'types', 'status', 'priorities'
] as const;

export function serializeSuggestionsFilters(f: ISuggestionsFilters): Params {
  return {
    clients: serializeNumberList(f.selectedClients),
    towns: serializeNumberList(f.selectedTowns),
    services: serializeIdList(f.selectedServices),
    types: serializeStringList(f.selectedTypes),
    status: serializeStringList(f.selectedStatus),
    priorities: serializeStringList(f.selectedPriorities),
  };
}

export function deserializeSuggestionsFilters(
  params: ParamMap,
  fallback?: ISuggestionsFilters
): ISuggestionsFilters {
  return {
    selectedClients: parseNumberList(params.get('clients')),
    selectedTowns: parseNumberList(params.get('towns')),
    selectedServices: parseIdList(params.get('services'), fallback?.selectedServices),
    selectedTypes: parseEnumList<SuggestionType>(params.get('types')),
    selectedStatus: parseEnumList<SuggestionStatus>(params.get('status')),
    selectedPriorities: parseEnumList<SuggestionPriority>(params.get('priorities')),
  };
}

export function parseSuggestionsFiltersFromStorage(json: string | null | undefined): ISuggestionsFilters | null {
  if (!json) return null;
  try {
    const f = JSON.parse(json);
    return {
      selectedClients: Array.isArray(f.selectedClients) ? f.selectedClients : [],
      selectedTowns: Array.isArray(f.selectedTowns) ? f.selectedTowns : [],
      selectedServices: Array.isArray(f.selectedServices) ? f.selectedServices : [],
      selectedTypes: Array.isArray(f.selectedTypes) ? f.selectedTypes : [],
      selectedStatus: Array.isArray(f.selectedStatus) ? f.selectedStatus : [],
      selectedPriorities: Array.isArray(f.selectedPriorities) ? f.selectedPriorities : [],
    };
  } catch {
    return null;
  }
}
